import React from "react";
import BusDetailsCard from "./BusDetailsCard";

export default function Bus11() {
  return (
    <BusDetailsCard
      busId="bus11"
      title="Bus 11 - Route Details"
      busName="Bus 11"
      vehicleNo="TN74K1234"
      backTo="/?buses=1"
    />
  );
}